import styled from '@emotion/styled';

const StyledName = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;
const StyledDepartment = styled.div`
  overflow: hidden;
  color: var(--dk-text-secondary, #888d96);
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  word-break: keep-all;
  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const StyledStatus = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid;
  width: fit-content;
  white-space: nowrap;
`;
const StyledStatusName = styled.div`
  color: var(--dk-text-primary, #34383d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  text-align: center;
`;
const StyledImg = styled.img<{ profileImgError: boolean }>`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
  object-fit: cover;
`;

const HoverBorder = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: translateX(-4px);
  border: 1px solid var(--dk-bg, white);
  transition: all 0.3s ease-in-out;
  opacity: 0;

  &:hover {
    width: 36px;
    height: 36px;
    border: 1px solid black;
    transform: translateX(-2px);
    opacity: 1;
  }
`;

const StyledDate = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  text-align: center;
`;

const AuthorLayout = styled.div<{ reduceMode: boolean }>`
  display: flex;
  align-items: center;
  justify-content: start;
  width: ${({ reduceMode }) => (reduceMode ? 'initial' : '196px')};
  position: ${({ reduceMode }) => (reduceMode ? 'relative' : 'auto')};
`;

const StatusLayout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 88px;
`;

const StyledButtonLayout = styled.a`
  display: flex;
  align-items: center;
  padding: 12px 8px;
  background-color: #fff;

  &:hover {
    background-color: #f9fafb;
  }
`;

const CustomDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--dk-bg-strong, #e7e9ec);
`;

export {
  StyledButtonLayout,
  StyledName,
  StyledDepartment,
  StyledStatus,
  StyledStatusName,
  StyledImg,
  StyledDate,
  AuthorLayout,
  StatusLayout,
  CustomDivider,
  HoverBorder,
};
